import { Button, FormControl, FormLabel, Heading, Select } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import IconGenerateReport from 'assets/icons/icon-file-paper-line.svg?react';
import CardForm from 'components/ui/CardForm';
import CustomRangeDatepicker from 'components/ui/Datepicker/CustomRangeDatepicker';
import FormControlGroup from 'components/ui/FormControlGroup';
import config from 'config';
import { useMessages } from 'hooks/useMessages';
import { useResourceList } from 'hooks/useResourceList';
import { ArrayRequiredMinLenTestFunction } from 'lib/validation';
import { FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useContentReport } from '../hooks/useContentReport';


interface FormValues {
  companyId: string;
  dates: Date[];
}

const validationSchema = Yup.object().shape({
  companyId: Yup.string(),
  dates: Yup.mixed().test('dates', '', ArrayRequiredMinLenTestFunction(2)),
});

export default function TabReportsReport() {
  const { onError } = useMessages();
  
  const { data: companies } = useResourceList({ 
    resourceName: 'companies'
  });

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as unknown as Resolver<FormValues>,
    defaultValues: {
      companyId: '',
      dates: []
    }
  });

  const { setValue, handleSubmit, register, watch, formState: { errors, isValid } } = methods;
  const dates = watch('dates');
  
  const { onGenerateContentReport, isPending } = useContentReport({
    onSuccess: (filepath: string) => {
      window.location.assign(`${config.api}/${filepath}`);
    },
    onError: (error) => onError(error?.response?.data?.message)
  });

  const onSubmit: SubmitHandler<FormValues> = ({ companyId, dates }) => {
    const [startsAt, endsAt] = dates;
    onGenerateContentReport({ companyId, startsAt, endsAt });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CardForm
          boxShadow="none"
          border="1px solid #E2E2E2"
          bgColor="rgba(240, 241, 242, 0.60)"
        >
          <Heading as="h3" size="h3">
            Gerar novo relatório
            <span>Preencha os filtros para gerar um novo relatório</span>
          </Heading>

          <FormControlGroup 
            mt="25px"
            mr="auto"
          >
            <FormControl isInvalid={!!errors.dates} isRequired>
              <FormLabel>Período</FormLabel>
              <CustomRangeDatepicker
                dates={dates ?? []}
                onDateChange={(dates: Date[]) => setValue('dates', dates, { shouldValidate: true })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Empresa</FormLabel>
            { companies && (
              <Select 
                placeholder="Todas as empresas"
                {...register('companyId')}
              >
                { companies.map((company) => (
                  <option key={company.id} value={company.id}>{company.name}</option>
                ))}
              </Select>
            )}
            </FormControl>        
          </FormControlGroup>
          
          <Button 
            variant="primary"
            type="submit"
            ml="auto"
            rightIcon={<IconGenerateReport />}
            isDisabled={isPending || !isValid}
            isLoading={isPending}
          >
            Gerar relatório
          </Button>

        </CardForm>
      </form>
    </FormProvider>
  )
}
